module.exports = __webpack_public_path__ + "bm.svg?e0a5a6bf1f2775704fd530e3c97af833";